/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetAccount200ResponseFeatureFlagsIntention } from './GetAccount200ResponseFeatureFlagsIntention';
import {
    GetAccount200ResponseFeatureFlagsIntentionFromJSON,
    GetAccount200ResponseFeatureFlagsIntentionFromJSONTyped,
    GetAccount200ResponseFeatureFlagsIntentionToJSON,
} from './GetAccount200ResponseFeatureFlagsIntention';

/**
 * 企業単位の機能フラグ
 * @export
 * @interface GetAccount200ResponseFeatureFlags
 */
export interface GetAccount200ResponseFeatureFlags {
    /**
     * 
     * @type {GetAccount200ResponseFeatureFlagsIntention}
     * @memberof GetAccount200ResponseFeatureFlags
     */
    intention?: GetAccount200ResponseFeatureFlagsIntention;
}

/**
 * Check if a given object implements the GetAccount200ResponseFeatureFlags interface.
 */
export function instanceOfGetAccount200ResponseFeatureFlags(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetAccount200ResponseFeatureFlagsFromJSON(json: any): GetAccount200ResponseFeatureFlags {
    return GetAccount200ResponseFeatureFlagsFromJSONTyped(json, false);
}

export function GetAccount200ResponseFeatureFlagsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccount200ResponseFeatureFlags {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'intention': !exists(json, 'intention') ? undefined : GetAccount200ResponseFeatureFlagsIntentionFromJSON(json['intention']),
    };
}

export function GetAccount200ResponseFeatureFlagsToJSON(value?: GetAccount200ResponseFeatureFlags | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'intention': GetAccount200ResponseFeatureFlagsIntentionToJSON(value.intention),
    };
}

